import { render, staticRenderFns } from "./GetCountDispatchesByRevenueCenters.vue?vue&type=template&id=f90fbba0&scoped=true&"
import script from "./GetCountDispatchesByRevenueCenters.vue?vue&type=script&lang=js&"
export * from "./GetCountDispatchesByRevenueCenters.vue?vue&type=script&lang=js&"
import style0 from "./GetCountDispatchesByRevenueCenters.vue?vue&type=style&index=0&id=f90fbba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90fbba0",
  null
  
)

export default component.exports